import { IArrivalTimeOption } from "@/domain/entities/lineInfo";
import { arrivalTimeOptions } from "@/types";
import { ref } from "vue";

export const useArrivalTimeOptions = () => {
  const selectedArrivalTimeOption = ref<IArrivalTimeOption>(
    arrivalTimeOptions[0]
  );

  const updateSelectedArrivalTimeOption = (option: IArrivalTimeOption) => {
    selectedArrivalTimeOption.value = option;
  };

  return {
    selectedArrivalTimeOption,
    updateSelectedArrivalTimeOption,
  };
};
